module.exports = __webpack_public_path__ + "img/map-marker-round-trip.e187f318.svg";